export default "__VITE_ASSET__C9XB_zX4__"